import { PropsWithChildren } from "react"

import { styled } from "@mui/material/styles"

const StyledSpan = styled("span")({
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
})

const SrOnly = ({ children }: PropsWithChildren) => {
  return <StyledSpan>{children}</StyledSpan>
}

export default SrOnly
